/* src/app/timeline-artic/modals/artic-set-job-modal/artic-set-job-modal.component.scss */
/*# sourceMappingURL=artic-set-job-modal.component.css.map */
